










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Step } from '@/interfaces/Step';

@Component({})
export default class ModuleStepListStepActivatorPickStepRequirements extends Vue {
  @Prop()
  step!: Step;
}
